import React, { Component } from "react";


class DialogInputBox extends React.Component
{
    
    constructor(props)
    {
        super(props);
        this.state =
        {
            value: this.props.value,
        }


    }


    setValue(value)
    {
        this.setState({value:value})
    }

    componentDidUpdate()
    {
        this.props.onChange()
    }
    getValue()
    {
        return this.state.value;
    }

    render()
    {
        
        var style = {marginLeft:"0px"};
        if (this.props.decale) style = {marginLeft:"20px"};
        if (this.props.decalevalue) style = {marginLeft:this.props.decalevalue};
        return (<>
        <label style={style}>
            <input className="dialog-InputBox" 
                    autoFocus={this.props.autoFocus}
                    type="checkbox"
                    onChange={e => this.setState({value:e.target.checked})}
                    checked={this.state.value}
                    disabled={this.props.disabled}
                    

                     />
            <span className = "dialog-InputBoxText" style={{marginLeft:"5px"}}>                     
            {this.props.title}
            </span>
        </label>
        </>);
    }

}
DialogInputBox.defaultProps = 
{
    autoFocus: false,
    width: 0,
    disabled: false,
    decale: false,
}

export default DialogInputBox